<template>
    <div style="width: 100%; height: 600px;">
        <l-map style="width: 100%; height: 100%;" :zoom="5" :center="[46.603354, 1.888334]">
            <l-geo-json :geojson="regions" :options-style="() => regionStyle" />
        </l-map>
    </div>
</template>

<script setup>
import 'leaflet/dist/leaflet.css'
import { LMap, LGeoJson } from '@vue-leaflet/vue-leaflet'

// GeoJSON réel
import regions from './layers/regions/regions_2015_metropole_region_exploded.json'


// Style de test simple
const regionStyle = {
    color: '#D4AF37',
    fillColor: '#FAEBD7',
    fillOpacity: 0.8,
    weight: 1
}
</script>
